var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vector", _vm._b({}, "vector", _vm.$props, false), [
    _c("rect", { attrs: { width: "50", height: "50", fill: _vm.color } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }